import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#0b0014] py-12 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_stock-mirrors/artifacts/gdgmfuzc_2.%20Logo%202.png" 
            alt="Stocks Protocol" 
            className="h-12 md:h-40 w-auto object-contain"
          />
          <p className="text-gray-500 text-xs md:text-sm text-center md:text-right">
            © 2024 - 2025 Stocks Protocol. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
